import {
  LabRequest,
  LabComment,
  LabCategoryOptions,
  LabServices,
  UploadLabDocumentPayload,
  LabTests,
  ProductSpeciesResponse,
  ProductVarietiesResponse,
} from '@app/models/labs/LabRequest';
import {
  LabTableData,
  LabTableRow,
  LabResponse,
  LabApiData,
  Parameters,
  UploadLabDocumentResponse,
  UploadLabReport,
} from '@app/models/labs/LabResponse';
import { post, get, remove } from './http.api';

//const cat_id = Number(localStorage.getItem('selected_category_id')) || 0;

export const getLabData = async (parameters: Parameters): Promise<LabTableData> => {
  try {
    const { data, status } = await get<any>(
      'lab_requests',
      {
        params: parameters,
      },
      true,
    );

    const labtaskdata: LabTableRow[] = data.lab_requests.data.map((labData: any) => ({
      id: labData.id,
      code: labData.code,
      type: labData.pr_type,
      status: labData.status,
    }));

    return {
      data: labtaskdata,
      pagination: {
        current: data.lab_requests.current_page,
        pageSize: data.lab_requests.per_page,
        total: data.lab_requests.total,
      },
      status_options: data.status_options,
    };
  } catch (error: any) {
    console.error('Error fetching Lab Tasks:', error);
    throw error;
  }
};

export const getAllLabTasks = async (): Promise<LabResponse> => {
  try {
    const { data, status } = await get<LabResponse>(`lab_requests`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getLabById = async (id: number): Promise<LabResponse> => {
  try {
    const { data, status } = await get<LabResponse>(`lab_requests/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeLabTask = async (labData: LabRequest & { type: string }) => {
  try {
    const response = await post<any>('lab_requests/create', labData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createLabTask = async (type?: string): Promise<LabApiData> => {
  try {
    const url = type ? `lab_requests/create?type=${type}` : `lab_requests/create`;
    const { data, status } = await get<LabApiData>(url, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showLabTask = async (id: number) => {
  try {
    const { data, status } = await get<LabApiData>(`lab_requests/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editLabTask = async (id: number) => {
  try {
    const { data, status } = await get<LabApiData>(`lab_requests/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateLabTask = async (id: number, UpdateLab: LabRequest) => {
  try {
    const { data, status } = await post<LabRequest>(`lab_requests/${id}/edit`, UpdateLab, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const updateLabStatus = async (id: number, action: any) => {
  try {
    const { data, status } = await post<LabRequest>(`lab_requests/${id}/do_action`, action, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    throw error;
  }
};

export const getLabServiceCategories = async (labRequestId: number, labDivisionId: number) => {
  try {
    const { data, status } = await get<LabCategoryOptions>(
      `lab_requests/${labRequestId}/get_lab_service_category_options`,
      { params: { lab_division_id: labDivisionId } },
      true,
    );
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const getLabServices = async (labRequestId: number, labServiceCategoryId: number) => {
  try {
    const { data, status } = await get<LabServices>(
      `lab_requests/${labRequestId}/get_lab_services`,
      { params: { lab_service_category_id: labServiceCategoryId } },
      true,
    );
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const storeOrupdateLabTests = async (id: number, dept_id: number, testData: LabTests) => {
  try {
    const response = await post(
      `lab_requests/${id}/lab_request_departments/${dept_id}/upsert_lab_request_category`,
      testData,
      undefined,
      true,
    );

    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const editOrviewLabTests = async (id: number, dept_id: number, test_id: number) => {
  try {
    const response = await get(
      `lab_requests/${id}/lab_request_departments/${dept_id}/lab_request_service_categories/${test_id}`,
      undefined,
      true,
    );

    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const updateLabresults = async (id: number, dept_id: number, test_id: number, testresults: any) => {
  try {
    const response = await post(
      `lab_requests/${id}/lab_request_departments/${dept_id}/lab_request_service_categories/${test_id}/update_lab_request_service_parameters`,
      testresults,
      undefined,
      true,
    );

    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const updateTestProcess = async (id: number, dept_id: number, test_id: number, action: any) => {
  try {
    const response = await post(
      `lab_requests/${id}/lab_request_departments/${dept_id}/lab_request_service_categories/${test_id}/do_action`,
      action,
      undefined,
      true,
    );

    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getProductSpecies = async (id: number, catId: number) => {
  try {
    const response = await get<ProductSpeciesResponse>(
      `lab_requests/${id}/get_products?product_category_id=${catId}`,
      undefined,
      true,
    );

    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getProductVarieties = async (id: number, catId: number) => {
  try {
    const response = await get<ProductVarietiesResponse>(
      `lab_requests/${id}/get_varieties?product_id=${catId}`,
      undefined,
      true,
    );

    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const updateOrCreateProduct = async (id: number, products: any) => {
  try {
    const response = await post(`lab_requests/${id}/upsert_products`, products, undefined, true);

    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

// export const storeLabComment = async (id: number, commentData: LabComment) => {
//   try {
//     const response = await post<any>(`lab_requests/${id}/store_comment`, commentData, undefined, true);
//     console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
//     return response.data;
//   } catch (error: any) {
//     console.error(`Error: ${error.status} - ${error.message}`);
//     throw error;
//   }
// };

// export const updateLabComment = async (id: number, com_id: number, commentData: LabComment) => {
//   try {
//     const { data, status } = await post<LabComment>(
//       `lab_requests/${id}/${com_id}/update_comment`,
//       commentData,
//       undefined,
//       true,
//     );
//     console.log(`Status: ${status}`, `Data: ${data}`);
//     return data;
//   } catch (error: any) {
//     console.error(`Error: ${error.status} - ${error.message}`);
//     throw new Error(`Error: ${error.status} - ${error.message}`);
//   }
//};

export const uploadLabCertificate = async (
  id: number,
  dept_id: number,
  test_id: number,
  formData: FormData,
): Promise<any> => {
  try {
    const { data, status } = await post<any>(
      `lab_requests/${id}/lab_request_departments/${dept_id}/lab_request_service_categories/${test_id}/upload_report`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    );
    console.log('Status:', status, 'Data:', data);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const generateLabInvoice = async (id: number, invoiceType: string) => {
  try {
    const response = await post<any>(
      `lab_requests/${id}/create_invoice`,
      { invoice_type: invoiceType },
      undefined,
      true,
    );
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getLabInvoice = async (id: number) => {
  try {
    const { data, status } = await get<any>(`/invoices/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const generateLabReport = async (id: number, dept_id: number, test_id: number) => {
  try {
    const response = await post<any>(
      `lab_requests/${id}/lab_request_departments/${dept_id}/lab_request_service_categories/${test_id}/generate_report`,
      undefined,
      undefined,
      true,
    );
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getLabReport = async (id: number) => {
  try {
    const { data, status } = await get<any>(`lab_requests/report/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const uploadLabDocument = async (
  labRequestId: string,
  labRequestDepartmentId: string,
  payload: UploadLabDocumentPayload,
): Promise<UploadLabDocumentResponse> => {
  try {
    const formData = new FormData();
    formData.append('name', payload.name);

    if (payload.id) {
      formData.append('id', payload.id.toString());
    }

    if (payload.file) {
      formData.append('file', payload.file);
    }

    const { data } = await post<UploadLabDocumentResponse>(
      `lab_requests/${labRequestId}/${labRequestDepartmentId}/upload_document`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return data;
  } catch (error: any) {
    console.error('Error uploading lab document:', error);
    throw error;
  }
};

export const setZeroInvoicing = async (id: number, dept_id: number, test_id: number, action: any) => {
  try {
    const response = await post<any>(
      `lab_requests/${id}/lab_request_departments/${dept_id}/lab_request_service_categories/${test_id}/update_billable_with_approved_status`,
      action,
      undefined,
      true,
    );
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const RemoveLabTest = async (id: number, dept_id: number, test_id: number) => {
  try {
    const response = await remove<any>(
      `lab_requests/${id}/lab_request_departments/${dept_id}/lab_request_service_categories/${test_id}/delete`,
      undefined,
      true,
    );
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const updateInvoice = async (invoiceId: number) => {
  try {
    const response = await post<any>(`invoices/${invoiceId}/set_to_paid`, undefined, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const updateBatchNo = async (id: number, dept_id: number, test_id: number, batchData: any) => {
  try {
    const response = await post<any>(
      `lab_requests/${id}/lab_request_departments/${dept_id}/lab_request_service_categories/${test_id}/update_batches_qty`,
      batchData,
      undefined,
      true,
    );
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const uploadLabResult = async (
  id: number,
  dept_id: number,
  test_id: number,
  formData: FormData,
): Promise<any> => {
  try {
    const { data, status } = await post<any>(
      `lab_requests/${id}/lab_request_departments/${dept_id}/lab_request_service_categories/${test_id}/upload_result_report`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    );
    console.log('Status:', status, 'Data:', data);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
